// 维保商机报备
import {dynamicPropsFn} from './util.js'

const MtReportOpportunityList = resolve => require(['@/views/MtReportOpportunity/List'], resolve)
const MtReportOpportunityDetail = resolve => require(['@/views/MtReportOpportunity/Detail'], resolve)
const MtReportOpportunityNew = resolve => require(['@/views/MtReportOpportunity/New'], resolve)
const MtReportOpportunityEdit = resolve => require(['@/views/MtReportOpportunity/Edit'], resolve)
const MtReportOpportunityJobNumberList = resolve => require(['@/views/MtReportOpportunity/JobNumber/List'], resolve)
const MtReportOpportunityJobNumberDetail = resolve => require(['@/views/MtReportOpportunity/JobNumber/Detail'], resolve)
const MtReportOpportunityJobNumberNew = resolve => require(['@/views/MtReportOpportunity/JobNumber/New'], resolve)
const MtReportOpportunityJobNumberEdit = resolve => require(['@/views/MtReportOpportunity/JobNumber/Edit'], resolve)
const ContactsList = resolve => require(['@/views/Contacts/ContactsList'], resolve)
const ContactsDetail = resolve => require(['@/views/Contacts/ContactsDetail'], resolve)
const ContactsNew = resolve => require(['@/views/Contacts/ContactsNew'], resolve)
const ContactsEdit = resolve => require(['@/views/Contacts/ContactsEdit'], resolve)

export default [
  {
    name: 'MtReportOpportunity_list',
    path: '/mtReportOpportunity/list',
    component: MtReportOpportunityList,
    meta: {
      keepAlive: false,
      title: '商机报备列表',
    },
  },
  {
    name: 'MtReportOpportunity_detail',
    path: '/mtReportOpportunity/list/detail',
    component: MtReportOpportunityDetail,
    // props: dynamicPropsFn,
    meta: {keepAlive: false},
  },
  {
    name: 'MtReportOpportunity_edit',
    path: '/mtReportOpportunity/list/edit',
    component: MtReportOpportunityEdit,
    props: dynamicPropsFn,
    meta: {keepAlive: false},
  },
  {
    name: 'MtReportOpportunity_new',
    path: '/mtReportOpportunity/list/new',
    component: MtReportOpportunityNew,
    props: dynamicPropsFn,
    meta: {keepAlive: false},
  },
  { // 商机报备工号列表
    name: 'JobNumber_list',
    path: '/mtReportOpportunity/list/detail/jobNumberList',
    component: MtReportOpportunityJobNumberList,
    props: dynamicPropsFn,
    meta: {keepAlive: false},
  },
  {
    name: 'JobNumber_detail',
    path: '/mtReportOpportunity/list/detail/jobNumberList/jobNumberDetail',
    component: MtReportOpportunityJobNumberDetail,
    props: dynamicPropsFn,
    meta: {keepAlive: false},
  },
  {
    name: 'JobNumber_new',
    path: '/mtReportOpportunity/list/detail/jobNumberList/jobNumberNew',
    component: MtReportOpportunityJobNumberNew,
    props: dynamicPropsFn,
    meta: {keepAlive: false},
  },
  {
    name: 'JobNumber_edit',
    path: '/mtReportOpportunity/list/detail/jobNumberList/jobNumberEdit',
    component: MtReportOpportunityJobNumberEdit,
    props: dynamicPropsFn,
    meta: {keepAlive: false},
  },
  {
    name: 'Contacts_list',
    path: '/mtReportOpportunity/list/detail/contactsList',
    component: ContactsList,
    props: dynamicPropsFn,
    meta: {keepAlive: false},
  },
  {
    name: 'Contacts_detail',
    path: '/mtReportOpportunity/list/detail/contactsList/contactsDetail',
    component: ContactsDetail,
    props: dynamicPropsFn,
    meta: {keepAlive: false},
  },
  {
    name: 'Contacts_new',
    path: '/mtReportOpportunity/list/detail/contactsList/contactsNew',
    component: ContactsNew,
    props: dynamicPropsFn,
    meta: {keepAlive: false},
  },
  {
    name: 'Contacts_edit',
    path: '/mtReportOpportunity/list/detail/contactsList/contactsDetail/contactsEdit',
    component: ContactsEdit,
    props: dynamicPropsFn,
    meta: {keepAlive: false},
  },
]



// WEBPACK FOOTER //
// ./src/router/mtReportOpportunity.js